<template>
  <div class="food-manage">
    <div class="tuolele-main-box">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="10日签到" name="10days">
          <div v-for="(chartValue, chartKey) in day10schart" :key="`echart-box-day10schart-${chartKey}`" style="margin-top: 10px;">
            <h3>{{ day10schart[chartKey].name }} </h3>
            <el-divider />
            <div :ref="`echart-box-day10schart-${chartKey}`" style="width: 100%;" :style="{width: '100%', height: '250px'}" />
          </div>
        </el-tab-pane>
        <el-tab-pane label="现金付款" name="cash">
          <div class="flex_box" style="margin-bottom: 10px;">
            <el-date-picker
              v-model="dateVal"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
            <el-button style="margin-left: 10px;" type="primary" @click="fnGetCashData()">搜索</el-button>
          </div>
          <el-alert :title="`托乐乐 - 总计：${cashData.tllTotalAmount} 元（支付宝、微信实际付款金额，不包含转账、余额支付等金额）` " type="warning" />
          <div>
            <h1 class="big_h1">{{ cashData.tll_taste_amount }}</h1>
            <h4>当日体验付款 </h4>
          </div>
          <div>
            <h1 class="big_h1">{{ cashData.tll_new_signing_amount }}</h1>
            <h4>当日新签付款</h4>
          </div>
          <div>
            <h1 class="big_h1">{{ cashData.tll_renew_amount }}</h1>
            <h4>当日续费付款</h4>
          </div>
          <div>
            <h1 class="big_h1">{{ cashData.tll_give_amount }}</h1>
            <h4>当日赠送付款（包含带金额内转）</h4>
          </div>
        </el-tab-pane>
        <el-tab-pane label="课耗金额" name="consume">
          <div ref="echart-box-consume" style="width: 100%;" :style="{width: '100%', height: '250px'}" />

        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- <div class="footer pagination-footer" style="text-align: center;">
        <el-pagination layout="prev, pager, next, slot, jumper" :current-page.sync="listQuery.p" prev-text="上一页" next-text="下一页" :total="total" :page-size="listQuery.limit" @current-change="fnGetPenaltyList" />
      </div> -->
  </div>

</template>
<script>

// import Select from '@/components/Select'
import echarts from 'echarts'
var moment = require('moment')

export default {
  name: 'DailyStatistics',
  components: {

  },
  data() {
    return {
      activeName: '10days',
      dateVal: moment().format('YYYY-MM-DD'),
      cashData: {
        tllTotalAmount: 0,
        tll_taste_amount: 0,
        tll_new_signing_amount: 0,
        tll_renew_amount: 0,
        tll_give_amount: 0
      },
      cosumeEchart: null,
      day10schart: {
        formal: {
          chart: null,
          name: '近期签到',
          options: {}
        },
        contrast: {
          name: '周签到环比',
          chart: null,
          options: {}
        },
        signin_time_count: {
          name: '两日签到时间数量环比（24小时制,如：周一及上周一）',
          chart: null,
          options: {}
        }
      }

    }
  },
  created() {
    this.fnSet10DaysChart()
  },
  methods: {
    destroyAllChart() {
      for (const key in this['10dayschart']) {
        if (this['10dayschart'][key].chart != null) {
          this['10dayschart'][key].chart.dispose()
          this['10dayschart'][key].chart = null
        }
      }
    },
    handleClick(tab, event) {
      console.log(this.activeName)
      switch (this.activeName) {
        case '10days':
          this.fnSet10DaysChart()
          break
        case 'cash':
          this.fnGetCashData()
          break
        default:
          this.fnConsumeChart()
          break
      }
    },
    fnConsumeChart() {
      if (this.cosumeEchart) {
        this.cosumeEchart.dispose()
        this.cosumeEchart = null
      }
      this.$http.consume().then(res => {
        if (res.data.tllFiveData && res.data.tllFiveData.length > 0) {
          this.cosumeEchart = echarts.init(this.$refs[`echart-box-consume`])
          this.cosumeEchart.setOption(this.consumeSetOptions(res.data.tllFiveData))
        }
      })
    },
    consumeSetOptions(options) {
      const dates = options.map(ele => ele.dayday)
      const x1 = options.map(ele => ele.amount)
      return {
        tooltip: {
          trigger: 'axis', // 坐标轴触发
          axisPointer: { // 坐标轴指示器配置项
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        xAxis: [{ type: 'category', data: dates, axisLabel: { color: '#666666' }}],
        yAxis: [{ type: 'value', axisLabel: { color: '#666666' }}],
        series: [
          { name: '金额', type: 'bar', barGap: 0, data: x1, itemStyle: { color: 'rgb(11, 98, 164)' }}
        ],
        grid: { x: 40, y: 25, x2: 0, y2: 25 }

      }
    },
    fnGetCashData() {
      this.$http.income({ today: this.dateVal }).then(res => {
        res.data.list.forEach(v => {
          var actual_amount = Math.floor(v.actual_amount)
          actual_amount = actual_amount.toFixed(2)// toFixed 必须是小数
          if (v.type == 1 && v.kpi_status != 6) {
            this.cashData.tllTotalAmount += parseFloat(actual_amount)
          }
          if (v.type == 1 && v.kpi_status == 1) {
            this.cashData.tll_taste_amount = actual_amount
          }
          if (v.type == 1 && v.kpi_status == 2) {
            this.cashData.tll_new_signing_amount = actual_amount
          }
          if (v.type == 1 && v.kpi_status == 4) {
            this.cashData.tll_renew_amount = actual_amount
          }
          if (v.type == 1 && v.kpi_status == 6) {
            this.cashData.tll_give_amount = actual_amount
          }
        })
      })
    },
    async fnSet10DaysChart() {
      this.destroyAllChart()
      const res = await this.$http.signCount()
      for (var key in res.data) {
        if (res.data[key].length > 0) {
          this.day10schart[key].chart = echarts.init(this.$refs[`echart-box-day10schart-${key}`][0])
          this.day10schart[key].chart.setOption(this[`${key}SetOptions`](res.data[key]))
        }
      }
    },
    signin_time_countSetOptions(options) {
      const dates = options.map(ele => ele.sign_in_time1)
      const x1 = options.map(ele => ele.count1)
      const x2 = options.map(ele => ele.count2)
      return {
        tooltip: {
          trigger: 'axis', // 坐标轴触发
          axisPointer: { // 坐标轴指示器配置项
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        xAxis: [{ type: 'category', data: dates, axisLabel: { color: '#666666' }}],
        yAxis: [{ type: 'value', axisLabel: { color: '#666666' }}],
        series: [
          { name: '上周签到人数', type: 'bar', barGap: 0, data: x1, itemStyle: { color: 'rgb(11, 98, 164)' }},
          { name: '本周签到人数', type: 'bar', data: x2, itemStyle: { color: '#7a92a3' }}
        ],
        grid: { x: 40, y: 25, x2: 0, y2: 25 }

      }
    },
    formalSetOptions(options) {
      const dates = options.map(ele => ele.date)
      const x1 = options.map(ele => ele.count)
      return {
        tooltip: {
          trigger: 'axis', // 坐标轴触发
          axisPointer: { // 坐标轴指示器配置项
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        xAxis: [{ type: 'category', data: dates, axisLabel: { color: '#666666' }}],
        yAxis: [{ type: 'value', axisLabel: { color: '#666666' }}],
        series: [
          { name: '签到数', type: 'bar', barGap: 0, data: x1, itemStyle: { color: 'rgb(11, 98, 164)' }}
        ],
        grid: { x: 40, y: 25, x2: 0, y2: 25 }

      }
    },
    contrastSetOptions(options) {
      const dates = options.map(ele => ele.date)
      const x1 = options.map(ele => ele.count1)
      const x2 = options.map(ele => ele.count2)
      return {
        tooltip: {
          trigger: 'axis', // 坐标轴触发
          axisPointer: { // 坐标轴指示器配置项
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        xAxis: [{ type: 'category', data: dates, axisLabel: { color: '#666666' }}],
        yAxis: [{ type: 'value', axisLabel: { color: '#666666' }}],
        series: [
          { name: '上周', type: 'bar', barGap: 0, data: x1, itemStyle: { color: 'rgb(11, 98, 164)' }},
          { name: '本周', type: 'bar', data: x2, itemStyle: { color: '#7a92a3' }}
        ],
        grid: { x: 40, y: 25, x2: 0, y2: 25 }
      }
    }
  }
}
</script>
<!-- <style lang="scss" scoped>
  h1{
    color:#666666!important;
    font-size: 50px!important
  }
  </style> -->
  <style lang="scss">
  .big_h1{
    color:#666666!important;
    font-size: 50px!important
  }

    .food-search {
    .tuolele-main-search-item {
      margin-bottom: 0;
      padding: 0;
      border: 0;
      .el-form--inline .el-form-item {
        display: block;
      }
      .split-time{
        margin-right: 20px;
      }
      .el-select,
      .el-input {
        width: 160px !important;
        margin-right: 20px;
      }
      span.select-date {
        margin-right: 10px;
      }
      .button-group {
        margin-left: 82px;
      }
    }
  }
  </style>
